import { FormattedMessage } from 'react-intl';


type BasicMessageModalProps = {
    modalContent: {
        title: string,
        text: string,
        testid: string,
        showLogoutButton: boolean
    },
    closeModal: Function
    logout?: Function
}

const BasicMessageModal = (props: BasicMessageModalProps) => {
    return (
        <div className="info-modal basic-message-modal panel radius-rectangle">
            <div className="panel-header">
                <h2 className="bold-title">{props.modalContent?.title}</h2>
                <button className="btn-close-modal" onClick={() => props.closeModal()} />
            </div>
            <div className="panel-content">
                <div className="modal-content align-left" data-testid={props.modalContent?.testid}>
                    {props.modalContent?.text}
                </div>
                {props.modalContent.showLogoutButton && props.logout
                    ? (
                        <button className="btn-blue full-width" onClick={() => props.logout!()}>
                            <FormattedMessage id="GLOBAL_LOGOUT" />
                        </button>
                    )
                    : (
                        <button className="btn-small-blue" onClick={() => props.closeModal()}>
                            <FormattedMessage id="GLOBAL_CLOSE" />
                        </button>
                    )
                }
            </div>
        </div>
    );
};

export default BasicMessageModal;